/* SLS V2 mobile/tablet accordion — preserve native Shopify header drawer,
   focus trap, all real menu URLs and View all links. Submenus expand inline. */
(() => {
  function setup(root) {
    if (root.dataset.slsAccordionReady === 'true') return;
    root.dataset.slsAccordionReady = 'true';

    // Capture BEFORE Dawn's MenuDrawer summary handler. Otherwise its
    // onSummaryClick() forces an off-screen submenu and traps focus there.
    root.addEventListener('click', (event) => {
      const summary = event.target.closest?.('.menu-drawer__navigation details > summary');
      if (!summary || !root.contains(summary)) return;
      const details = summary.parentElement;
      if (!(details instanceof HTMLDetailsElement)) return;
      event.preventDefault();
      event.stopPropagation();
      const opening = !details.open;
      details.open = opening;
      summary.setAttribute('aria-expanded', String(opening));
      if (!opening) {
        details.querySelectorAll('details[open]').forEach((child) => {
          child.open = false;
          child.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        });
      }
    }, true);

    // Escape collapses one inline branch, not the entire drawer. Escape from
    // the hamburger/root is still handled by Shopify's native MenuDrawer.
    root.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') return;
      const details = event.target.closest?.('.menu-drawer__navigation details[open]');
      if (!details) return;
      event.preventDefault();
      event.stopPropagation();
      details.open = false;
      const summary = details.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', 'false');
      summary?.focus();
    }, true);

    // Native outer-drawer closure clears descendant open state. Keep ARIA
    // truth aligned when Shopify resets all details on close.
    root.addEventListener('toggle', (event) => {
      if (event.target.matches?.('.menu-drawer__navigation details')) {
        event.target.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(event.target.open));
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('header-drawer[data-sls-accordion]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
